import { get } from 'svelte/store';
import { planning, scenarioManager } from '../../../stores/store';
import { Const } from '../../../stores/Const';

export function getFilterAssignmentId(
    showSuggestedDeliveries: boolean,
    showUnassignedDeliveries: boolean,
    isDefault: boolean,
    assignmentId: number,
    selectedDay: string
) {
    // console.warn(
    //     'getFilterAssignmentId',
    //     showSuggestedDeliveries,
    //     showUnassignedDeliveries,
    //     isDefault,
    //     assignmentId,
    //     selectedDay
    // );
    if (!isDefault) {
        switch (assignmentId) {
            case Const.ASSIGNMENT_UNSET:
                return {
                    assignment_id: Const.ASSIGNMENT_UNSET,
                    suggested_assignment_id: null,
                    x_target_date: selectedDay,
                };
            case Const.ASSIGNMENT_ADHOC:
                let assignmentIds = get(scenarioManager)
                    .getScenarioSections()
                    .map(a => a.getId())
                    .filter(a => a > 0);
                let filter: any = {
                    'job.target_date': get(scenarioManager).getDay(),
                    'job.ad_hoc': true,
                };
                switch (get(planning).currentQuickCategoryId) {
                    case 'to_assign':
                        filter.assignment_id = Const.ASSIGNMENT_UNSET;
                        filter.suggested_assignment_id = null;
                        break;
                    case 'to_approve':
                        filter.assignment_id = Const.ASSIGNMENT_UNSET;
                        filter.suggested_assignment_id = { $in: assignmentIds };
                        break;
                    case 'to_send':
                        filter.assignment_id = { $in: assignmentIds };
                        filter['$or'] = [
                            { 'details.in_realisation::boolean': false },
                            { 'details.in_realisation': null },
                        ];
                        break;
                    case 'in_progress':
                        filter.assignment_id = { $in: assignmentIds };
                        filter['details.in_realisation::boolean'] = true;
                        break;
                    default:
                        filter['$or'] = [
                            { assignment_id: Const.ASSIGNMENT_UNSET },
                            { assignment_id: { $in: assignmentIds } },
                            { suggested_assignment_id: { $in: assignmentIds } },
                        ];
                }
                return filter;
        }
    }
    let query = {};
    if (showUnassignedDeliveries) {
        if (showSuggestedDeliveries) {
            query = {
                $and: [
                    { assignment_id: { $in: [Const.ASSIGNMENT_UNSET, assignmentId] } },
                    {
                        $or: [
                            { suggested_assignment_id: null },
                            { suggested_assignment_id: assignmentId },
                        ],
                    },
                ],
                $not: {
                    // not show rejected jobs
                    'job.rejected_assignments': {
                        $has: assignmentId,
                    },
                },
            };
        } else {
            query = {
                $and: [
                    { assignment_id: { $in: [Const.ASSIGNMENT_UNSET, assignmentId] } },
                    { suggested_assignment_id: null },
                ],
                $not: {
                    // not show rejected jobs
                    'job.rejected_assignments': {
                        $has: assignmentId,
                    },
                },
            };
        }
    } else if (showSuggestedDeliveries) {
        query = {
            $or: [{ assignment_id: assignmentId }, { suggested_assignment_id: assignmentId }],
            $not: {
                // not show rejected jobs
                'job.rejected_assignments': {
                    $has: assignmentId,
                },
            },
        };
    } else {
        query = {
            assignment_id: assignmentId,
            $not: {
                // not show rejected jobs
                'job.rejected_assignments': {
                    $has: assignmentId,
                },
            },
        };
    }
    if (Object.keys(query).length > 0) {
        return {
            ...query,
            x_target_date: selectedDay,
        };
    }
    return {
        assignment_id: assignmentId,
        x_target_date: selectedDay,
    };
    // {"$or":[{"$and":[{"assignment_id":{"$in":[0,45595]}},{"x_target_date":"2024-02-29"}]},{"$or":[{"assignment_id":45595},{"suggested_assignment_id":45595}]}]}
}
